<template>
  <div>
    <header-component @search="search"/>
    <header-scroll
        v-if="scroll"
        @search="search"
    />
    <notification
        :notification="notification"
    />
    <login
        v-if="page === 'login'"
        @loginUser="loginUser"
        @message="sendNotification"
    />
    <register
        v-if="page === 'register'"
        @message="sendNotification"
    />
    <restore-password
        v-if="page === 'restore-password'"
        @message="sendNotification"
    />
    <section
        v-if="page !== 'login' && page !=='register' && page !=='restore-password'"
        class="main"
        @message="sendNotification"
    >
      <div class="container">
        <div class="columns">
          <sidebar
              :current-user="currentUser"
              :badge="badge"
              @logout="logout"
              @search="search"
              @updateProfilePicture="updateProfilePicture"
          />
          <div class="column is-9">
            <transition
                name="component-fade"
                mode="out-in"
            >
              <component
                  :is="page"
                  class="mobile-margin"
                  :user="currentUser.user"
                  :token="currentUser.token"
                  :region="currentUser.region"
                  :friends="friends"
                  :region-list="regionList"
                  :login-user="loginUser"
                  @updateMessagesCount="getUnreadMessages"
                  @message="sendNotification"
                  @updateProfilePicture="updateProfilePicture"
                  @updateName="updateName"
              />
            </transition>
          </div>
        </div>
      </div>
    </section>
    <footer-component/>
    <modals-container/>
  </div>
</template>

<script>
import HeaderComponent from './header/Header.vue'
import HeaderScroll from './header/HeaderScroll.vue'
import Home from './home/Content.vue'
import Login from './auth/LoginUser.vue'
import Register from './auth/SignupUser.vue'
import RestorePassword from './auth/RestorePassword.vue'
import Terms from './Terms.vue'
import FooterComponent from './Footer.vue'
import Sidebar from './sidebar/Sidebar.vue'
import News from './news/News.vue'
import NewsDetails from './news/WholeNews.vue'
import Location from './location/Location.vue'
import LocationRegion from './location/SelectRegion.vue'
import Rules from './rules/Rules.vue'
import Jobs from './jobs/Jobs.vue'
import Services from './services/Services.vue'
import ServicesEvents from './services/Events.vue'
import ServicesJoin from './services/Join.vue'
import ServicesFee from './services/Fee.vue'
import AboutUs from './home/AboutUs.vue'
import Contact from './contact/Contact.vue'
import ContactForm from './home/ContactForm.vue'
import Calendar from './calendar/Main.vue'
import Standing from './standing/StandingMain.vue'
import Races from './standing/Races.vue'
import RacesPrint from './standing/RacesPrint.vue'
import MyPoints from './userAccount/MyPoints.vue'
import MyBonuses from './userAccount/MyBonuses.vue'
import MyMessages from './userAccount/MyMessages.vue'
import VenueDetails from './venues/VenueDetails.vue'
import TournamentDetails from './tournaments/TournamentDetails.vue'
import AccountEdit from './userAccount/AccountEdit.vue'
import SetRegion from './userAccount/SetRegion.vue'
import PlayerDetails from './players/PlayerDetails.vue'
import MyAhl from './userAccount/MyAhl.vue'
import Comparition from './userAccount/Comparition.vue'
import ComparitionThree from './userAccount/ComparitionThree.vue'
import FourZeroFour from './FourZeroFour.vue'
import SearchResults from './SearchResults.vue'
import Notification from './helpers/Notification.vue'
import Countdown from './helpers/Countdown.vue'
import Shop from './shop/Index.vue'
import Slideout from './helpers/Slideout.vue'
import SpecialEvents from './home/SpecialEvents'
import EmailSubscribe from './home/EmailSubscribe'

// Virtual Poker
import VirtualPoker from './vpoker/Index.vue'

// Admin
import Tools from './admin/news/Index.vue'
import ToolsCreate from './admin/news/Create.vue'
import ToolsEdit from './admin/news/Edit.vue'
import ToolsMembers from './admin/members/Index.vue'
import ToolsTournaments from './admin/tournaments/Index.vue'
import ToolsTournamentsMissing from './admin/tournaments/MissingTournaments.vue'
import ToolsTournamentsLate from './admin/tournaments/LateTournaments.vue'
import ToolsTournamentCreate from './admin/tournaments/Create.vue'
import ToolsTournamentApprove from './admin/tournaments/ApproveTourn.vue'
import ToolsEditHosts from './admin/hosts/List.vue'
import ToolsEditHost from './admin/hosts/Edit.vue'
import ToolsAddHost from './admin/hosts/Add.vue'
import ToolsBannedMembers from './admin/members/Banned.vue'
import ToolsVenuesList from './admin/venues/List.vue'
import ToolsVenuesEdit from './admin/venues/Edit.vue'
import ToolsVenuesCreate from './admin/venues/Create.vue'
import SupportEmails from './admin/supportemails/Index.vue'
import ToolsEditCalendar from './admin/calendar/Edit.vue'
import TournamentCard from './admin/tournaments/TournamentCard.vue'
import ToolsEmailList from './admin/lists/EmailMembers.vue'
import ToolsListLists from './admin/lists/ListLists.vue'
import ToolsListAdd from './admin/lists/ListAdd.vue'
import ToolsListEdit from './admin/lists/ListEdit.vue'
import ToolsFranchiseCreateInvoice from './admin/franchises/CreateInvoice.vue'
import ToolsEditRules from './admin/ToolsEditRules.vue'
import ToolsEditEventTags from './admin/ToolsEditTags.vue'
import axios from 'axios'
import Vue from 'vue'
import VueMq from 'vue-mq'

import SyncLoader from './helpers/SyncLoader'

Vue.component('sync-loader', SyncLoader)
Vue.prototype.$axios = axios;
Vue.use(VueMq, {
  breakpoints: {
    mobile: 1023,
    tablet: 1024,
    desktop: 1300,
    xdesktop: Infinity
  }
})

export default {
  name: 'Main',
  metaInfo: {
    title: 'AHL Poker'
  },
  components: {
    EmailSubscribe,
    HeaderComponent,
    HeaderScroll,
    Home,
    Login,
    Register,
    RestorePassword,
    FooterComponent,
    Sidebar,
    News,
    NewsDetails,
    Location,
    LocationRegion,
    Rules,
    Jobs,
    Services,
    ServicesEvents,
    ServicesJoin,
    ServicesFee,
    AboutUs,
    Contact,
    ContactForm,
    Calendar,
    Standing,
    Races,
    RacesPrint,
    MyPoints,
    MyMessages,
    VenueDetails,
    TournamentDetails,
    AccountEdit,
    SetRegion,
    PlayerDetails,
    MyAhl,
    Comparition,
    ComparitionThree,
    FourZeroFour,
    SearchResults,
    Notification,
    Tools,
    ToolsCreate,
    ToolsEdit,
    ToolsEditEventTags,
    ToolsMembers,
    ToolsTournaments,
    ToolsTournamentsMissing,
    ToolsTournamentsLate,
    ToolsTournamentCreate,
    ToolsTournamentApprove,
    ToolsEditHosts,
    ToolsEditHost,
    ToolsAddHost,
    ToolsBannedMembers,
    ToolsEditCalendar,
    TournamentCard,
    Countdown,
    Terms,
    Slideout,
    'sync-loader': SyncLoader,
    ToolsEmailList,
    ToolsListLists,
    ToolsListAdd,
    ToolsListEdit,
    'mybonuses': MyBonuses,
    'tools-franchise-createinvoice': ToolsFranchiseCreateInvoice,
    'tools-venues-edit': ToolsVenuesEdit,
    'tools-venues-list': ToolsVenuesList,
    'tools-venues-create': ToolsVenuesCreate,
    'tools-support-emails': SupportEmails,
    'tools-edit-rules': ToolsEditRules,
    'tools-edit-eventtags': ToolsEditEventTags,
    'special-events': SpecialEvents,
    Shop,
    VirtualPoker
  },
  props: ['page'],
  data() {
    return {
      isSliderOpen: false,
      currentUser: {user: null, token: null},
      scroll: false,
      notification: null,
      showNotification: false,
      badge: 0,
      friends: '',
      regionList: ''
    }
  },
  watch: {
    // Scroll top on desctop
    '$route'(to, from) {
      if (window.innerWidth > 1023) {
        scrollTo(0, 0)
      } else {
        scrollTo(0, innerHeight)
      }
    }
  },
  created() {
    if (localStorage.isLoggedIn) {
      this.currentUser = JSON.parse(localStorage.isLoggedIn)
    }
    window.onscroll = () => {
      this.detectScroll()
    }
  },
  mounted() {
    if (this.currentUser.user) {
      this.getUnreadMessages()
    }
    this.getRegionList()
  },
  methods: {
    toggleSlider() {
      this.$refs.slideout.slideout.toggle()
    },
    loginUser(user) {
      this.currentUser = user
    },
    logout() {
      if (this.currentUser) {
        this.$axios({
          method: 'POST',
          url: `authenticate/logout`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.currentUser.token
          }
        })
            .then((res) => {
              if (res.data && !res.data.user) {
                localStorage.setItem('isLoggedIn', false)
                this.currentUser.user = null
                this.currentUser.isImpersonated = false
              } else {
                this.currentUser.user = res.data.user
                this.currentUser.isImpersonated = res.data.isImpersonated
                localStorage.setItem('isLoggedIn', JSON.stringify(this.currentUser))
              }
              if (res.data.message) {
                this.$emit(res.data.error, res.data.message)
              }
              this.$router.push('/')
            })
            .catch((error) => {
              console.log(error)
            })
      }
    },
    detectScroll() {
      if (window.scrollY > 175 && window.innerWidth > 1007) {
        this.scroll = true
      } else this.scroll = false
    },
    search(criteria) {
      this.$router.push({path: '/search-results', query: {search: criteria}})
    },
    sendNotification(message) {
      this.notification = message
      this.showNotification = true
      setTimeout(() => {
        this.showNotification = false
      }, 5000)
    },
    getUnreadMessages() {
      if (this.currentUser && this.currentUser.user && this.currentUser.user.ahlid) {
        this.$axios({
          method: 'POST',
          url: `general/memberfriends/${this.currentUser.user.ahlid}/true`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.currentUser.token || ''
          }
        })
            .then((res) => {
              for (let i = 0; i < res.data.length; i++) {
                this.badge += +res.data[i].unread
              }
              this.friends = res.data
            })
            .catch((error) => {
              this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
            })
      }
    },
    updateProfilePicture() {
      this.$axios({
        method: 'POST',
        url: `member/profilepic/${this.currentUser.token}/get`,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.currentUser.token || ''
        }
      })
          .then((res) => {
            this.currentUser.user.memberphoto = res.data.memberphoto
            localStorage.setItem('isLoggedIn', JSON.stringify(this.currentUser))
          })
          .catch((error) => {
            console.log(error)
          })
    },
    updateName(first, middle, last) {
      this.currentUser.user.first = first
      this.currentUser.user.middle = middle
      this.currentUser.user.last = last
      let storage = JSON.parse(localStorage.getItem('isLoggedIn'))
      storage.user.first = first
      storage.user.middle = middle
      storage.user.last = last
      localStorage.setItem('isLoggedIn', JSON.stringify(storage))
    },
    getRegionList() {
      this.$axios({
        method: 'POST',
        url: `general`,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: {
          token: this.currentUser.token || ''
        }
      })
          .then((res) => {
            let rList = res.data.regionList.map((region) => {
              return {name: region.regionId + ": " + region.name, counties: region.name, regionId: region.regionId}
            })
            this.regionList = rList
          })
          .catch((error) => {
            console.log(error.response)
          })
    }
  }
}
</script>

<style>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
